<div class="header">
  <div class="navbar">
    <img
      src="../../../assets/logos/oc_colour.svg"
      alt="Oceancaster Logo"
    />
    <h2 *ngIf="!this.showProjectTitle" class="title">Evidence Viewer</h2>
    <h2 *ngIf="this.showProjectTitle">{{ this.projectName }}</h2>
    <app-header-menu></app-header-menu>
  </div>
</div>
